import React, { FC, useMemo } from 'react';

import SideNavigation from '@adsk/alloy-side-navigation';

const DEFAULT_NUMBER_OF_FAKE_ITEMS = 10;

const RemoteSideNavigationLoader: FC = () => {
  const placeholderItems = useMemo(
    () =>
      Array.from({ length: DEFAULT_NUMBER_OF_FAKE_ITEMS }, (_, key) => ({
        loading: true,
        key: `fake_item_${key}`,
      })),
    [],
  );

  return <SideNavigation topItems={placeholderItems} />;
};

export default RemoteSideNavigationLoader;
